module.exports = __webpack_public_path__ + "img/tax-empty.7503058a.svg";